import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Home from './views/Home.vue'
import Agreement from './views/Agreement.vue'
import Calendar from './views/Calendar.vue'
import Ledger from './views/Ledger.vue'
import Profile from './views/Profile.vue'
import Login from './views/Login.vue'
import BindDevice from './views/BindDevice.vue'
import Payment from './views/Payment.vue'
import SimpleAgreement from './views/SimpleAgreement.vue'
import FormalAgreements from './views/FormalAgreements.vue'
import { ensureLogin, hasLogin } from './api'
import './style.css'

Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    { path: '/', component: Home },
    { path: '/login', component: Login },
    { path: '/bind-device', component: BindDevice, meta: { auth: true } },
    { path: '/agreement', component: Agreement, meta: { auth: true } },
    { path: '/calendar', component: Calendar, meta: { auth: true } },
    { path: '/ledger', component: Ledger, meta: { auth: true } },
    { path: '/payment', component: Payment, meta: { auth: true } },
    { path: '/simple-agreement', component: SimpleAgreement, meta: { auth: true } },
    { path: '/formal-agreements', component: FormalAgreements, meta: { auth: true } },
    { path: '/profile', component: Profile, meta: { auth: true } }
  ]
})
router.beforeEach(async (to, from, next) => {
  if (!to.meta.auth) return next()
  try {
    if (!hasLogin()) sessionStorage.setItem('oauthReturnPath', to.fullPath)
    const uid = await ensureLogin()
    if (uid) { sessionStorage.removeItem('oauthReturnPath'); next() }
  } catch (e) {
    alert('微信授权登录失败，请稍后重试')
    next(false)
  }
})
new Vue({ router, render: h => h(App) }).$mount('#app')
